import React from "react";
import {
  BenchlingC,
  OpenPhilC,
  IDTC,
  GinkgoC,
  TwistC,
  BeckmanC,
} from "../../assets/media";
import "./styles.scss";

export const Sponsors = (): JSX.Element => (
  <div className="sp">
    <div>
      <h1>Sponsors</h1>
      <p>
        As a non-profit organization, we count on the support of our partners
        and sponsors to help us continue to provide this unique and valuable
        experience to students worldwide. Thank you to all of everyone below who
        have helped make iGEM possible.
      </p>
    </div>
    <hr />
    <div className="sp-block">
      <h2>Platinum Partner Sponsors</h2>
      <div className="sp-card">
        <div className="sp-card-img-wrapper">
          <img alt="ginkgo" src={GinkgoC} />
        </div>
        <div className="sp-card__body">
          <a
            href="https://www.ginkgobioworks.com"
            target="_blank"
            rel="noreferrer"
          >
            <h6>Ginkgo Bioworks</h6>
          </a>
          <p>
            Ginkgo Bioworks is the organism company. Founded by some of the
            earliest participants in iGEM, Ginkgo develops tools to make biology
            easier to engineer, with applications in consumer products, food and
            agriculture, health and medicine, and beyond. To learn more about
            Ginkgo and see open job postings, visit ginkgobioworks.com.
          </p>
        </div>
      </div>
      <div className="sp-card">
        <div className="sp-card-img-wrapper">
          <img alt="idt" src={IDTC} />
        </div>
        <div className="sp-card__body">
          <a
            href="https://2021.igem.org/Sponsors/IDT"
            target="_blank"
            rel="noreferrer"
          >
            <h6>Integrated NDA Technologies (IDT)</h6>
          </a>
          <p>
            IDT is a leader in the development and manufacture of products for
            research and diagnostic life sciences. As the world’s largest
            supplier of custom nucleic acids, IDT serves academic research,
            biotechnology, and pharmaceutical development communities with
            products that support applications including next generation
            sequencing (NGS), gene amplification, SNP detection, expression
            profiling, gene quantification, and synthetic biology.
            Platform-independent NGS products (xGen™ Lockdown™ Probes for
            improved target capture, custom adaptors, fusion primers, molecular
            identifier tags—MIDs) are available in addition to DNA and RNA
            oligonucleotides, qPCR assays, siRNA duplexes, gBlocks™ Gene
            Fragments for gene construction, and custom gene synthesis.
          </p>
        </div>
        <div className="sp-card__additional">
          <h6>
            Our 8-year partnership with IDT has transformed the way iGEMers
            around the world approach synthetic biology. Registered iGEM 2021
            Competition teams can get up to 20 kb free custom DNA from IDT.
            <br />
            <br />
            See more about IDT&apos;s ground-breaking offer at the{" "}
            <a
              href="https://2021.igem.org/Sponsors/IDT"
              target="_blank"
              rel="noreferrer"
            >
              IDT partner page.
            </a>
          </h6>
        </div>
      </div>
      <div className="sp-card">
        <div className="sp-card-img-wrapper">
          <img alt="open-phi" src={OpenPhilC} />
        </div>
        <div className="sp-card__body">
          <a
            href="https://www.openphilanthropy.org/"
            target="_blank"
            rel="noreferrer"
          >
            <h6>Open Philantrophy</h6>
          </a>
          <p>
            Open Philanthropy identifies outstanding giving opportunities, makes
            grants, follows the results, and publishes its findings. Its mission
            is to give as effectively as it can and share the findings openly so
            that anyone can build on them.
          </p>
        </div>
        <div className="sp-card__additional">
          <h6>
            Thank you to Open Philanthropy for supporting iGEM’s{" "}
            <a href="http://igem.org/Safety" target="_blank" rel="noreferrer">
              Safety & Security Program.
            </a>
          </h6>
        </div>
      </div>
      <div className="sp-card">
        <div className="sp-card-img-wrapper">
          <img alt="twist" src={TwistC} />
        </div>
        <div className="sp-card__body">
          <h6>Twist Bioscience</h6>
          <p>
            At Twist Bioscience, we work in service of customers who are
            changing the world for the better. In fields such as medicine,
            agriculture, industrial chemicals and data storage, by using our
            synthetic DNA tools, our customers are developing ways to better
            lives and improve the sustainability of the planet. The faster our
            customers succeed, the better for all of us, and Twist Bioscience is
            uniquely positioned to help accelerate their efforts.{" "}
          </p>
        </div>
      </div>
    </div>
    <hr />
    <div className="sp-block">
      <h2>Partner Sponsors</h2>
      <div className="sp-card">
        <div className="sp-card-img-wrapper">
          <img alt="beckman" src={BeckmanC} />
        </div>
        <div className="sp-card__body">
          <a
            href="https://2021.igem.org/Sponsors/Beckman_Coulter"
            target="_blank"
            rel="noreferrer"
          >
            <h6>Beckman Coulter</h6>
          </a>
          <p>
            Beckman Coulter&apos;s commitment to your research dates to our
            origin in 1935. For more than 80 years, we have been a trusted
            partner for laboratory professionals, helping to advance scientific
            research and patient care. Beckman Coulter Life Sciences and
            Beckman.com is a global resource for millions of life science
            researchers, industrial and environmental technicians, and
            pharmaceutical and biomedical scientists.
          </p>
        </div>
      </div>
      <div className="sp-card">
        <div className="sp-card-img-wrapper">
          <img alt="benchling" src={BenchlingC} />
        </div>
        <div className="sp-card__body">
          <a
            href="https://2021.igem.org/Sponsors/Benchling"
            target="_blank"
            rel="noreferrer"
          >
            <h6>Benchling</h6>
          </a>
          <p>
            Benchling is the first cloud-based platform powering synthetic
            biology research and making breakthrough discoveries faster than
            ever before. Replacing outdated pen and paper processes, Benchling
            offers a unified solution purpose-built for biotech that includes
            Notebook, an electronic laboratory notebook, and Molecular Biology,
            a suite of sequence design and analysis tools. Benchling is used by
            over 320,000 scientists worldwide to centralize data collection,
            design biological sequences, and collaborate more efficiently. With
            Benchling, you and your iGEM team spend less time on busywork and
            more time focusing on science.
          </p>
        </div>
        <div className="sp-card__additional">
          <h6>
            For a third year in a row, Benchling is helping iGEM teams make
            research discoveries faster! To learn more about Benchling&apos;s
            exciting offer for iGEM teams, visit{" "}
            <a
              href="https://2021.igem.org/Sponsors/Benchling"
              target="_blank"
              rel="noreferrer"
            >
              Benchling&apos;s Partner Page.
            </a>
          </h6>
        </div>
      </div>
    </div>
    <hr />
    <div className="sp-block">
      <h2>Gold Sponsors</h2>
      <ul>
        <li>
          <h6>Agilent</h6>
          <p />
        </li>
        <li>
          <h6>Battelle</h6>
          <p>
            Battelle’s vision is to be a major force in science and technology
            discovery and in the translation of knowledge into innovative
            applications that have significant societal and economic impacts.
          </p>
        </li>
        <li>
          <h6>New England Biolabs</h6>
          <p>
            Established in the mid 1970’s, New England Biolabs, Inc. (NEB) is
            the industry leader in the discovery and production of enzymes for
            molecular biology applications and now offers the largest selection
            of recombinant and native enzymes for genomic research. NEB
            continues to expand its product offerings into areas related to PCR,
            gene expression, sample preparation for next generation sequencing,
            synthetic biology, glycobiology, epigenetics and RNA analysis.
            Additionally, NEB is focused on strengthening alliances that enable
            new technologies to reach key market sectors, including molecular
            diagnostics development. New England Biolabs is a privately held
            company and is proud to be a Certified B Corporation™. NEB has
            extensive worldwide distribution through a network of exclusive
            distributors, agents and eight subsidiaries located in Australia,
            Canada, China, France, Germany, Japan, Singapore and the UK. For
            more information about New England Biolabs visit www.neb.com.
          </p>
        </li>
      </ul>
    </div>
  </div>
);
